var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("hamburger", {
        staticClass: "hamburger-container",
        attrs: { id: "hamburger-container", "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toolbar-menu left-menu" },
        [
          _vm.device !== "mobile"
            ? [
                _c("header-search", { staticClass: "toolbar-menu-item" }),
                _vm._v(" "),
                _c("error-log", {
                  staticClass: "errLog-container toolbar-menu-item hover-effect"
                }),
                _vm._v(" "),
                _c("screenfull", {
                  staticClass: "toolbar-menu-item hover-effect"
                }),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: _vm.$t("navbar.size"),
                      effect: "dark",
                      placement: "bottom"
                    }
                  },
                  [
                    _c("size-select", {
                      staticClass: "toolbar-menu-item hover-effect"
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("lang-select", {
                  staticClass: "toolbar-menu-item hover-effect"
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toolbar-menu right-menu" },
        [
          _vm.userCanChat
            ? _c(
                "div",
                { staticClass: "toolbar-menu-item hover-effect" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "danger", round: "" },
                      on: {
                        click: function($event) {
                          _vm.displayChat = !_vm.displayChat
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "el-icon-chat-square" }),
                      _c("span", [_vm._v(_vm._s(_vm.chatCounter))])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container toolbar-menu-item hover-effect",
              attrs: { trigger: "click" }
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("em", { staticClass: "el-icon-user-solid" }, [
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-family": "helvetica" } }, [
                    _vm._v(_vm._s(_vm.username))
                  ])
                ]),
                _vm._v(" "),
                _c("em", { staticClass: "el-icon-arrow-down" })
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", { attrs: { divided: "" } }, [
                    _c("span", [
                      _c("em", { staticClass: "el-icon-s-custom" }),
                      _vm._v(" My Account")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.logout($event)
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { display: "block" } }, [
                            _c("em", { staticClass: "el-icon-switch-button" }),
                            _vm._v(
                              " \n            " +
                                _vm._s(_vm.$t("global.menu.account.logout")) +
                                "\n          "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.displayChat
        ? _c("chat-room", { on: { close: _vm.closeChat } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }